// extracted by mini-css-extract-plugin
module.exports = {"container":"_26phfa","logo":"J8mveA","text":"_1AIvJj"};